import { render, staticRenderFns } from "./TripReport.vue?vue&type=template&id=b2f36904&"
import script from "./TripReport.vue?vue&type=script&lang=js&"
export * from "./TripReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports